import { useMutation } from "@apollo/client"
import CustomButton from "components/Atoms/CustomButton"
import CustomFormGroup from "components/Atoms/CustomFormGroup"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import FileUploadDialog from "components/Templates/FileUploadDialog"
import Codenames from "constants/codenames"
import { AllBanksSelectorQuery } from "generated/graphql"
import { DELETE_DC_PAYMENT_METHOD } from "graphql/distribution-center/distribution-center.mutations.gql"
import React, { useState } from "react"
import useDCStore from "../dc.store"
import FormCard from "../FormCard"
import useDCRemoveM2M from "../useDCRemoveM2M"
import IFSCInput from "./IFSCInput"

type PaymentMethodProps = {
  data?: any
  index?: number
  allBanks: AllBanksSelectorQuery["allBanks"]
}

export const PAYMENT_METHOD_TYPES = [
  {
    id: "BANK",
    name: "Bank",
  },
  {
    id: Codenames.UPI,
    name: "UPI",
  },
]
const PaymentMethod = ({ data, index, allBanks }: PaymentMethodProps) => {
  const removeListItem = useDCStore(store => store.removeListItem)
  const method = data?.paymentMethod?.id
  const [mutate] = useMutation(DELETE_DC_PAYMENT_METHOD)
  const { removeLink } = useDCRemoveM2M()
  const [isFileUploadOpen, setUpload] = useState(false)

  return (
    <FormCard
      onRemove={() => {
        if (data?.id) {
          mutate({
            variables: { ids: [data?.id] },
            onCompleted: () => removeListItem("paymentMethods", index, true),
          })
        } else {
          removeListItem("paymentMethods", index)
        }
      }}
      title={data?.accountNumber || method || `Payment Method ${index + 1}`}
    >
      <StaticSelector
        required
        path={`${index}.paymentMethod`}
        label="Payment Method"
        items={PAYMENT_METHOD_TYPES}
      />
      {!method ? null : (
        <>
          <StringInput
            required
            big={false}
            label={method === "UPI" ? "UPI ID" : "Account Number"}
            path={`${index}.accountNumber`}
          />
          <CustomFormGroup label="Attachments">
            <CustomButton
              className="self-center w-full"
              icon="cloud-upload"
              text="Upload Files"
              onClick={e => setUpload(true)}
            />
          </CustomFormGroup>

          <FileUploadDialog
            btnClassName="self-end"
            path={`${index}.attachments`}
            isOpen={isFileUploadOpen}
            onClose={() => setUpload(false)}
            onDelete={photo => {
              if (!data?.id && photo?.id) return
              removeLink({
                fieldName: "attachments",
                fieldIds: [photo?.id],
                modelId: data?.id,
                displayName: "Bank Attachment",
                modelName: "vt_core.BankDetail",
              })
            }}
          />
        </>
      )}

      {method === "BANK" && (
        <>
          <StringInput
            required
            big={false}
            label={"Account Holder's Name"}
            path={`${index}.accountHolderName`}
          />
          <IFSCInput allBanks={allBanks} index={index} />
          <StringInput
            disabled
            big={false}
            label={"Bank Name"}
            path={`${index}.bank.name`}
          />
          <StringInput
            disabled
            big={false}
            label={"Branch Name"}
            path={`${index}.branchName`}
          />
        </>
      )}
    </FormCard>
  )
}

export default PaymentMethod
